import * as React from "react";
import { forwardRef } from "react";
const SvgStatusUntracked = ({
  title,
  titleId,
  ...props
}, ref) => <svg width={16} height={16} viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" ref={ref} aria-labelledby={titleId} {...props}>{title ? <title id={titleId}>{title}</title> : null}<g fill="none" fillRule="evenodd"><path d="M0 0h16v16H0z" /><rect stroke="currentColor" fill="#0D0E24" x={0.5} y={0.5} width={15} height={15} rx={7.5} /></g></svg>;
const ForwardRef = forwardRef(SvgStatusUntracked);
export { ForwardRef as ReactComponent };